import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ModelMap } from '@app/models/core/model-map.collection';
import { AuthService } from '@app/services';
import { Employee } from '@models/employee/employee.model';

@Injectable()
export class EmployeeResolver {
    constructor(
        private auth: AuthService,
        private router: Router
    ) {}
    resolve(route: ActivatedRouteSnapshot): Promise<ModelMap> {
        return new Promise<ModelMap>(async (resolve, reject) => {
            const models = new ModelMap();
            const employeeId = route.queryParams.employeeId ?? this.auth.employee.id;

            try {
                const employee = await Employee.param('company', this.auth.company.id)
                    .with([
                        'activeTimeOffPolicies',
                        'activeTimeOffPolicies.timeOffType',
                        'activeTimeOffPolicies.timeOffRequestRule',
                        'activeTimeOffPolicies.timeOffSeniorityOverrides',
                        'allAssignedTimeOffPolicies',
                        'allAssignedTimeOffPolicies.timeOffType',
                        'allAssignedTimeOffPolicies.timeOffRequestRule',
                        'allAssignedTimeOffPolicies.timeOffSeniorityOverrides',
                    ])
                    .find(employeeId);
                models.set('employee', employee);

                return resolve(models);
            } catch {
                this.router.navigate(['/']);

                return reject();
            }
        });
    }
}
